import { ReactNode } from 'react';
import { Tab } from 'semantic-ui-react';

export function getPaneCfg(name: string, content: ReactNode) {
    return {
        menuItem: name,
        render: () => <Tab.Pane>{content}</Tab.Pane>,
    };
}
